import { forwardRef } from "react";

const InlineInput = forwardRef((props, ref) => {
  return(
    <div className={props.divClass ?  props.divClass : "row mb-3"}>
        {props.required ? <label htmlFor={props.name} className={props.classname ? props.classname : "col-form-label bold-label col-sm-3"}>
            {props.title}
        </label>: <label htmlFor={props.name} className={props.classname ? props.classname : "col-form-label bold-label col-sm-3"}>
            {props.title}*
        </label>}
      <div className={props.inputClass ? props.inputClass : "col-7"}>
        {props.required ?
          <input 
            type={props.type}
            className={props.className}
            id={props.name}
            ref={ref}
            name={props.name}
            placeholder={props.placeholder}
            onChange={props.onChange}
            autoComplete={props.autoComplete}
            value={props.value}
            step={props.step}
            required
          />
          :
          <input
            type={props.type}
            className={props.className}
            id={props.name}
            ref={ref}
            name={props.name}
            placeholder={props.placeholder}
            onChange={props.onChange}
            autoComplete={props.autoComplete}
            value={props.value}
            step={props.step}     
          />
        }
      </div>
    </div>
  )
  
})

export default InlineInput;